import { Injectable } from "@angular/core";
import { Internal } from "../decorators/app.decorators";
import { VCPM } from 'pcs-domain';
import { VcfSizingOutput } from 'pcs-domain';
import { Store } from "@ngxs/store";
import { ProjectDetailsState } from "../../store/project-details/project-details.state";
import { PcsSizingEngineResponse } from 'pcs-domain';
import { AuthService } from "../../components/auth/auth.service";
import {
    ReportPayloadContext,
    buildReportPayload as buildReportPayloadPure,
    addSummaryToMgmtDomainRecommendation as addSummaryToMgmtDomainRecommendationPure,
    addSummaryToWorkloadDomainRecommendation as addSummaryToWorkloadDomainRecommendationPure,
    normalizeWorkloadDomains as normalizeWorkloadDomainsPure,
    normalizeManagementDomain as normalizeManagementDomainPure,
    roundToTwo as roundToTwoPure,
    roundAnyValue as roundAnyValuePure,
    getTemplateVersion as getTemplateVersionPure,
} from 'pcs-domain';

@Internal()
@Injectable({
    providedIn: 'root'
})
export class ReportServiceRequestAdapterService {

    constructor(private store: Store, private authService: AuthService) {
    }

    getReportServiceRequest(project: VCPM.Project) {
        const savedSummary: VcfSizingOutput.Summary | undefined = this.store.selectSnapshot(ProjectDetailsState.getSavedSummary);
        const profile = this.authService.profile$.value;
        const context: ReportPayloadContext = {
            user: { name: profile?.name, email: profile?.email, user_loginid: profile?.user_loginid },
            savedSummary,
        };
        return buildReportPayloadPure(project, context);
    }

    addSummaryToMgmtDomainRecommendation(managementDomainRecommendation: PcsSizingEngineResponse.RecommendationResponse | undefined, managementDomainSummary: VcfSizingOutput.ManagementDomain | undefined) {
        return addSummaryToMgmtDomainRecommendationPure(managementDomainRecommendation, managementDomainSummary);
    }

    addSummaryToWorkloadDomainRecommendation(workloadDomainRecommendations: Array<PcsSizingEngineResponse.Recommendation> | undefined, workloadDomainSummary: Array<VcfSizingOutput.WorkloadDomain> | undefined) {
        return addSummaryToWorkloadDomainRecommendationPure(workloadDomainRecommendations, workloadDomainSummary);
    }

    /**
     * Normalizes workload domains by replacing driveSize with customDriveSize when "other" is selected
     */
    private normalizeWorkloadDomains(workloadDomains: VCPM.WorkloadDomain[] | undefined): any[] | undefined {
        return normalizeWorkloadDomainsPure(workloadDomains);
    }

    /**
     * Normalizes management domain by replacing driveSize with customDriveSize when "other" is selected
     */
    private normalizeManagementDomain(managementDomain: VCPM.ManagementDomain | undefined): any | undefined {
        return normalizeManagementDomainPure(managementDomain);
    }

    private roundToTwo(value: number | undefined): number | undefined {
        return roundToTwoPure(value);
    }

    /**
     * Rounds a numeric value to two decimal places while preserving the original type.
     */
    private roundAnyValue(val: any): any {
        return roundAnyValuePure(val);
    }

    /**
     * Determines the template version to use based on the project version
     * @param projectVersion The project version (e.g., "9.0.0", "5.2.1")
     * @returns The version string to use in template IDs
     */
    private getTemplateVersion(projectVersion: string | undefined): string {
        return getTemplateVersionPure(projectVersion);
    }

}
